import React from 'react';
import Label from 'shared/components/label';
import Dropdown from 'src/components/dropdown';
import {educationPhaseOptions} from 'src/constants';
import {setFromTargetValue} from '../../../utils/form';
import PropTypes from 'prop-types';

const propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

const EducationPhaseDropdown = (props) => {
  const {value, onChange} = props;
  return (
    <Label>
      Select Program Education Phase
      <Dropdown
        name="educationPhase"
        options={educationPhaseOptions}
        value={value}
        onChange={setFromTargetValue(onChange)}
      />
    </Label>
  );
};

EducationPhaseDropdown.propTypes = propTypes;

export default EducationPhaseDropdown;
